import React from 'react'

const PartyAvailableModalDetails = () => (
  <div>
    <h1 className="modal-header">FYI, this style is not available for group rental.</h1>
    <p className="modal-text">
      This style is popular. As the owner of this event, you can reserve this item for yourself.
      It’s not available for other people in your group to rent
    </p>
    <p className="modal-text">
      You won’t be able to check out if other people in your group are wearing this item.
    </p>
  </div>
)

export default PartyAvailableModalDetails
